// Shopify AJAX Cart API
function phCapture(name, props) {
  try { if (window.posthog && posthog.capture) posthog.capture(name, props || {}); } catch (e) {}
}

async function addToCartAjax(variantId, qty) {
  qty = qty || 1;
  var res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: parseInt(variantId), quantity: qty})
  });
  if (!res.ok) { var e = await res.json(); throw new Error(e.description || 'Cannot add to cart'); }
  return res.json();
}

async function getCartData() {
  return fetch('/cart.js').then(r => r.json());
}

async function syncCartFromServer() {
  try { updateCartUI(await getCartData()); } catch(e) { console.error('Cart:', e); }
}

function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

function updateCartUI(cart) {
  document.querySelectorAll('.cart-count, #cartCount').forEach(el => { el.textContent = cart.item_count; });
  var sub = document.getElementById('cartSubtotal');
  if (sub) sub.textContent = formatMoney(cart.total_price);
  renderCartItems(cart.items);
  var footer = document.getElementById('cartFooter');
  if (footer) footer.style.display = cart.item_count > 0 ? 'block' : 'none';
}

// --- Cart update via /cart/update.js (reliable, correct response) ---
// updates = { variantId: newQty, ... }
async function cartUpdate(variantId, newQty) {
  try {
    var updates = {};
    updates[variantId] = newQty;
    var res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({updates: updates})
    });
    var cart = await res.json();
    updateCartUI(cart);
  } catch(e) {
    showToast('Could not update cart');
    console.error(e);
  }
}

function removeCartItem(variantId) {
  phCapture('cart_item_removed', { variant_id: variantId });
  cartUpdate(variantId, 0);
}

function changeQty(variantId, delta, currentQty) {
  var newQty = currentQty + delta;
  if (newQty < 0) return;
  phCapture('cart_quantity_changed', { variant_id: variantId, new_quantity: newQty });
  cartUpdate(variantId, newQty);
}

function renderCartItems(items) {
  var body = document.getElementById('cartBody');
  if (!body) return;
  if (!items || items.length === 0) {
    body.innerHTML =
      '<div class="cart-empty">' +
      '<p class="cart-empty-title">Your cart is empty</p>' +
      '<p class="cart-empty-sub">Add some fan gear to get started.</p>' +
      '<button class="btn-outline" onclick="closeCart()" style="font-size:11px;padding:12px 28px;">Continue Shopping</button>' +
      '</div>';
    return;
  }
  body.innerHTML = items.map(function(item) {
    var vid = item.variant_id;
    var qty = item.quantity;
    var imgSrc = item.image || '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    var thumb = imgSrc ? '<img src="' + imgSrc + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' : '';
    var qBtn = 'style="width:26px;height:26px;border:1px solid #ddd;background:#fff;cursor:pointer;font-size:16px;line-height:1;border-radius:4px;display:flex;align-items:center;justify-content:center;color:#333;"';
    return (
      '<div class="cart-line">' +
      '<div class="cart-line-swatch" style="overflow:hidden;border-radius:4px;flex-shrink:0;">' + thumb + '</div>' +
      '<div style="flex:1;min-width:0;">' +
        '<p class="cart-line-title">' + (item.product_title || '') + '</p>' +
        (variant ? '<p class="cart-line-variant">' + variant + '</p>' : '') +
        '<div style="display:flex;align-items:center;gap:8px;margin-top:8px;">' +
          '<button onclick="changeQty(' + vid + ',-1,' + qty + ')" ' + qBtn + '>-</button>' +
          '<span style="font-size:14px;min-width:20px;text-align:center;color:#111;">' + qty + '</span>' +
          '<button onclick="changeQty(' + vid + ',1,' + qty + ')" ' + qBtn + '>+</button>' +
        '</div>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:space-between;flex-shrink:0;padding-left:8px;">' +
        '<button onclick="removeCartItem(' + vid + ')" style="background:none;border:none;cursor:pointer;color:#bbb;font-size:18px;line-height:1;padding:0;" aria-label="Remove">&times;</button>' +
        '<p class="cart-line-price" style="margin-top:auto;">' + formatMoney(item.line_price) + '</p>' +
      '</div>' +
      '</div>'
    );
  }).join('');
}

// Add to cart
async function handleAdd(variantId, title, btn) {
  if (!variantId) { showToast('Product unavailable'); return; }
  var orig = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  try {
    await addToCartAjax(variantId);
    await syncCartFromServer();
    phCapture('add_to_cart', { variant_id: variantId, product_title: title || '', source: 'product_card' });
    showToast((title ? title.split('–')[0].trim() : 'Item') + ' added');
    openCart();
  } catch(e) {
    showToast('Something went wrong');
    console.error(e);
  }
  if (btn) { btn.textContent = orig || 'Add to Cart'; btn.disabled = false; }
}

function cardAction(btn) {
  if (btn.dataset.action === 'size') openSizeModal(btn.dataset.variants, btn.dataset.title);
  else handleAdd(btn.dataset.variantId, btn.dataset.title, btn);
}

// Size modal
var _sizeVars = [], _selVid = null, _sizeProdTitle = '';

function openSizeModal(variantsJson, productTitle) {
  try { _sizeVars = JSON.parse(variantsJson); } catch(e) { _sizeVars = []; }
  _sizeProdTitle = productTitle || 'Product';
  _selVid = null;
  phCapture('size_modal_opened', { product_title: _sizeProdTitle });
  var titleEl = document.getElementById('sizeModalTitle');
  if (titleEl) titleEl.textContent = _sizeProdTitle;
  var grid = document.getElementById('sizeGrid');
  if (grid) {
    grid.innerHTML = _sizeVars.map(function(v) {
      return '<button class="size-btn"' + (v.available === false ? ' disabled' : '') +
        ' onclick="pickSize(' + v.id + ',this)">' + v.title + '</button>';
    }).join('');
  }
  var btn = document.getElementById('sizeConfirmBtn');
  if (btn) { btn.disabled = true; btn.textContent = 'Add to Cart'; }
  var modal = document.getElementById('sizeModal');
  if (modal) modal.classList.add('open');
}

function pickSize(vid, btn) {
  _selVid = vid;
  phCapture('size_selected', { variant_id: vid, product_title: _sizeProdTitle, size: btn ? btn.textContent : '' });
  document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  var cb = document.getElementById('sizeConfirmBtn');
  if (cb) cb.disabled = false;
}

async function confirmSize() {
  if (!_selVid) return;
  var btn = document.getElementById('sizeConfirmBtn');
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  try {
    await addToCartAjax(_selVid);
    await syncCartFromServer();
    phCapture('add_to_cart', { variant_id: _selVid, product_title: _sizeProdTitle, source: 'size_modal' });
    closeSizeModal();
    showToast((_sizeProdTitle || 'Item').split('–')[0].trim() + ' added');
    openCart();
  } catch(e) {
    showToast('Something went wrong');
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
  }
}

function closeSizeModal() {
  var modal = document.getElementById('sizeModal');
  if (modal) modal.classList.remove('open');
  _selVid = null;
}

function handleModalBg(e) {
  if (e.target === document.getElementById('sizeModal')) closeSizeModal();
}

// Cart drawer
function openCart() {
  phCapture('cart_drawer_opened');
  var d = document.getElementById('cartDrawer'), o = document.getElementById('cartOverlay');
  if (d) d.classList.add('open');
  if (o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  var d = document.getElementById('cartDrawer'), o = document.getElementById('cartOverlay');
  if (d) d.classList.remove('open');
  if (o) o.classList.remove('open');
  document.body.style.overflow = '';
}

var _toastTimer = null;
function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => t.classList.remove('show'), 2800);
}

function initReveal() {
  var obs = new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('visible'); obs.unobserve(en.target); } });
  }, {threshold: 0.1, rootMargin: '0px 0px -32px 0px'});
  document.querySelectorAll('.reveal:not(.visible)').forEach(el => obs.observe(el));
}

document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  syncCartFromServer();
  var qs = new URLSearchParams(location.search);
  if (qs.get('customer_posted') === 'true') {
    phCapture('newsletter_subscribed');
    showToast('You are on the list! Use code LUVEVE10 for 10% off.');
  }
  if (qs.get('restock_posted') === 'true') {
    phCapture('restock_subscribed', { product_path: location.pathname });
    showToast('You are on the list. We will email you when it is back.');
  }
});
